import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon } from "react-bootstrap";

const renderRow = (agent, onEdit, isReadOnly) => (
    <tr key={agent.Id}>
        <td>{agent.Name}</td>
        <td>{agent.Phone}</td>
        <td>{agent.ContactPerson}</td>
        <td>{agent.Description}</td>
        <td>{agent.IsActive ? 'Да' : 'Нет'}</td>
        <td>
            <Glyphicon 
                glyph='pencil' 
                className={`edit-glyph${isReadOnly ? '.disabled' : ''}`} 
                onClick={isReadOnly ? undefined : () => onEdit(agent)} 
                title='Изменить' />
        </td>
    </tr>);

export const Table = ({ agents, fetching, onEdit, isReadOnly }) => (
    <div>
        {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
        {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
        {fetching === fetchingState.FETCHED &&
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <td>Название агента</td>
                        <td>Телефон</td>
                        <td>Контактное лицо</td>
                        <td>Комментарий</td>
                        <td>Дейстует?</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {agents.map(d => renderRow(d, onEdit, isReadOnly))}
                </tbody>
            </table>}
    </div>);


// WEBPACK FOOTER //
// ./src/components/settings/agents/Table.jsx